import React, { useState } from 'react';
import SupervisorAgentPopover from './SupervisorAgentPopover';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { selectActiveProfileActiveUntil } from 'flow/selectors/ExtensionSelectors';
import { useAppSelector } from 'flow/hooks/useRedux';

import moment from 'moment/moment';
import SimplePopover from 'flow/components/ui-components/SimplePopover';

interface Props {
    agentKey: ExtensionKey;
    threshold: number;
}

const SupervisorBarAgentSoonLoggedIn = ({ agentKey, threshold }: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const [referenceElement, setReferenceElement] = useState<any>();
    const profileActiveUntil = useAppSelector((state) =>
        selectActiveProfileActiveUntil(state, agentKey),
    );

    return (
        <div className="flex h-3 w-2 hover:h-4 hover:w-3">
            <div
                className="relative flex w-full rounded-xs bg-gray-400"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                ref={setReferenceElement}
            >
                <div
                    className="w-full bg-gray-300"
                    style={{
                        height: `${100 - getProgress(profileActiveUntil, threshold)}%`,
                    }}
                />
            </div>
            {isHovered ? (
                <SimplePopover
                    referenceElement={referenceElement}
                    placement="bottom"
                >
                    <SupervisorAgentPopover agentKey={agentKey} />
                </SimplePopover>
            ) : null}
        </div>
    );
};

export default React.memo(SupervisorBarAgentSoonLoggedIn);

const getProgress = (profileEndTimestamp: string, timeThreshold: number) => {
    const now = moment();

    if (now.isAfter(profileEndTimestamp)) {
        return 100;
    }

    const timeDuration = moment
        .duration(moment(profileEndTimestamp).diff(now))
        .asMilliseconds();

    if (timeDuration > timeThreshold) {
        return 0;
    }

    const progress = Math.round(100 - (timeDuration / timeThreshold) * 100);

    if (progress > 100) return 100;
    if (progress < 0) return 0;
    return progress;
};
